import { RECAPTCHA_V3_KEY } from './recaptcha.constants'
import { verifyTokenRecaptchaV3 } from './recaptcha.api'

const EXECUTE_TIMEOUT = 8000

type GrecaptchaV3 = {
    ready: (callback: () => void) => void
    execute: (siteKey: string, options: { action: string }) => Promise<string>
}

declare global {
    interface Window {
        grecaptcha?: GrecaptchaV3
    }
}

let scriptPromise: Promise<void> | undefined

const loadScript = () => {
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            const badgeStyle = document.createElement('style')
            badgeStyle.innerHTML = '.grecaptcha-badge { visibility: hidden; }'
            document.head.appendChild(badgeStyle)

            const script = document.createElement('script')
            script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_V3_KEY}`
            script.onload = () => {
                if (!window.grecaptcha?.ready) {
                    reject(new Error('recaptcha v3 unavailable'))
                    return
                }
                window.grecaptcha.ready(resolve)
            }
            script.onerror = reject
            document.head.appendChild(script)
        })
    }

    return scriptPromise
}

export const verifyReCaptchaV3 = async (action: string) => {
    try {
        await loadScript()

        const token = await Promise.race([
            window.grecaptcha?.execute(RECAPTCHA_V3_KEY, { action }),
            new Promise<never>((_, reject) => setTimeout(() => reject(new Error('recaptcha v3 timeout')), EXECUTE_TIMEOUT))
        ])

        if (!token) return false

        const data = await verifyTokenRecaptchaV3(token)

        return data.gg_success === true && data.isAccepted === true && data.success === true
    } catch {
        return false
    }
}
